<template>
	<div>
		<el-dialog title="详情" :visible.sync="dialogVisible" width="500px">
			<div class="cont-box">
				<div class="tit-name">旧机图片</div>
				<div class="img-minh">
					<image-upload
						class="img-box"
						:editMode="false"
						v-for="(item, index) in oldMachinePhotos"
						:key="index"
						:imageUrl.sync="item"
					/>
				</div>
			</div>
			<div class="cont-box">
				<div class="tit-name">不一致图片</div>
				<div class="img-minh">
					<image-upload
						class="img-box"
						:editMode="false"
						v-for="(item, index) in atypismPhotos"
						:key="index"
						:imageUrl.sync="item"
					/>
				</div>
			</div>
			<div class="cont-box">
				<div class="tit-name">不完整图片</div>
				<div class="img-minh">
					<image-upload
						class="img-box"
						:editMode="false"
						v-for="(item, index) in defectPhotos"
						:key="index"
						:imageUrl.sync="item"
					/>
				</div>
			</div>
      <div class="cont-box">
				<div class="tit-name">实收旧机照片</div>
				<div class="img-minh">
					<image-upload
						class="img-box"
						:editMode="false"
						v-for="(item, index) in exactMachinePhotos"
						:key="index"
						:imageUrl.sync="item"
					/>
				</div>
			</div>

			<!-- <div class="cont-box">
				<div class="tit-name">质检图片</div>
				<div class="img-minh">
					<image-upload
						class="img-box"
						:editMode="false"
						v-for="(item, index) in zhijianPhotos"
						:key="index"
						:imageUrl.sync="item"
					/>
				</div>
			</div> -->

			<div class="cont-box" v-if="isNoShowCompleteDataFlag">
				<div class="tit-name">旧机完整度</div>
				<el-table
					ref="completeTableData"
					:data="completeTableData"
					:reserve-selection="true"
					center
					height="40vh"
				>
					<el-table-column label="质检项" prop="title" min-width="140"></el-table-column>
					<el-table-column label="结果" prop="result" min-width="140"></el-table-column>
				</el-table>
			</div>

			<div class="cont-box">
				<div class="tit-name">异常报备</div>
				<div class="normal-text">{{ oldMachineRecycleOrder.reportRemark }}</div>
			</div>

			<div class="cont-box">
				<div class="tit-name">旧机记录</div>
				<el-table
					ref="recordTableData"
					:data="recordTableData"
					:reserve-selection="true"
					center
					height="40vh"
				>
					<el-table-column
						label="节点"
						prop="feedbackName"
						min-width="140"
					></el-table-column>
					<el-table-column
						label="时间"
						prop="createdDate"
						min-width="140"
					></el-table-column>
				</el-table>
			</div>

			<div class="cont-box" v-if="spotCheck">
				<div class="tit-name">抽检信息</div>
				<div class="normal-text">内外机是否一致：{{ spotCheck.consistent == 1 ? '一致' : '不一致' }}</div>
				<div class="normal-text">空调螺帽数量：{{ spotCheck.airConditionerNutNum }}</div>
				<div class="normal-text">情况说明：{{ spotCheck.remark }}</div>
				<div class="normal-text">抽检人：{{ spotCheck.stopCheckName }}</div>
				<div class="cont-box">
				<div class="tit-name">抽检图片</div>
				<div class="img-minh">
					<image-upload
						class="img-box"
						:editMode="false"
						v-for="(item, index) in choujianPhotos"
						:key="index"
						:imageUrl.sync="item"
					/>
				</div>
			</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import imageUpload from "@/components/Upload/ImageUpload"
export default {
	components: {
		imageUpload
	},
	data() {
		return {
      dialogVisible: false,
			oldMachinePhotos: [],
			atypismPhotos: [],
			defectPhotos: [],
			zhijianPhotos: [],
			choujianPhotos:[],
      exactMachinePhotos:[],
			completeTableData: [],
			recordTableData: [],
			categoryStr: '',
			// 旧机回收订单信息
			oldMachineRecycleOrder: {
				reportRemark: ''
			},
			spotCheck: []
		}
	},
	computed: {
		isNoShowCompleteDataFlag () {
			return ['空调', '平板电视', '洗衣机', '冰箱'].includes(this.categoryStr)
		}
	},
	methods: {
		// 打开弹框, categoryStr = 空调，平板电视,洗衣机,冰箱
		opendDialog (orderNo, categoryStr) {
			// console.log('===orderNo', orderNo, categoryStr)
			this.orderNo = orderNo
			this.categoryStr = categoryStr
			this.dialogVisible = true
			this.getOrderDetFun()
		},
		// 取消弹框
		cancelBtnFun() {
			this.dialogVisible = false
		},
		// 确认
		confirmBtnFun() {
			this.dialogVisible = false
		},
		getOrderDetFun () {
			const url = `/autoapp-default-server-recovery/api/jd/recycle/order/getDetail/${this.orderNo}`
			this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
					// console.log('===res===', res)
					const {
						feedbackList = [],// 旧机记录
						jdOldMachineRecycleDetail = {},// 完整度
						machineAnnexList = [],// 图片
						oldMachineRecycleOrder, // 旧机回收订单
						jdStopCheck = []//抽检信息
					} = res.data
					this.oldMachineRecycleOrder = Object.assign({}, this.oldMachineRecycleOrder, oldMachineRecycleOrder)
					this.recordTableData = feedbackList
					this.spotCheck = jdStopCheck
					// 旧机照片101 102, 不完整照片103, 缺失照片104
					const zhijianPhotos = machineAnnexList.filter((item) => [100].includes(item.annexType))
					const oldMachinePhotos = machineAnnexList.filter((item) => [100, 101, 102].includes(item.annexType))
					const atypismPhotos = machineAnnexList.filter((item) => item.annexType == 103)
					const defectPhotos = machineAnnexList.filter((item) => item.annexType == 104)
					const choujianPhotos = machineAnnexList.filter((item) => item.annexType == 110)
          const exactMachinePhotos = machineAnnexList.filter((item) => [105,106].includes(item.annexType))
					this.zhijianPhotos = zhijianPhotos.map((item) => item.annexId)
					this.oldMachinePhotos = oldMachinePhotos.map((item) => item.annexId)
					this.atypismPhotos = atypismPhotos.map((item) => item.annexId)
					this.defectPhotos = defectPhotos.map((item) => item.annexId)
					this.choujianPhotos = choujianPhotos.map((item) => item.annexId)
          this.exactMachinePhotos = exactMachinePhotos.map((item) => item.annexId)
					// console.log('===this.oldMachinePhotos', this.oldMachinePhotos)
					// 质检项目构建展示
					const {
						// 空调
						connectingPipe,
						inWindBlade,
						exWindBlade,
						inElectricalMachinery,
						exElectricalMachinery,
						inCover,
						exUnitExternal,
						exBoard,
						exBaseplate,
						powerLine,
						compressor,
						evaporator,
						condenser,
						// 冰箱
						compressorBaseplate,
						upperLowerDoor,
						locker,
						topCover,
						// 洗衣机
						shell,
						spinBucket,
						bucketSlot,
						electricMachinery,
						pedestal,
						// 电视机
						externalScreen
					} = jdOldMachineRecycleDetail
					const connectingPipeStrMap = {
						0: '无',
						1: '铜管',
						2: '铝管'
					}
					const valStrMap = {
						0: '无',
						1: '有'
					}
					// const completeMap = {
					// 	0: '否',
					// 	1: '是'
					// }
					if (this.categoryStr == '空调') {
						// 空调品类
						this.completeTableData = [
							{
								title: '连接管',
								result: connectingPipeStrMap[connectingPipe]
							},
							{
								title: '内机风叶',
								result: valStrMap[inWindBlade]
							},
							{
								title: '内机电机',
								result: valStrMap[inElectricalMachinery]
							},
							{
								title: '外机风叶',
								result: valStrMap[exWindBlade]
							},
							{
								title: '外机电机',
								result: valStrMap[exElectricalMachinery]
							},
							{
								title: '内机面板',
								result: valStrMap[inCover]
							},
							{
								title: '外机外罩',
								result: valStrMap[exUnitExternal]
							},
							{
								title: '外机顶盖',
								result: valStrMap[exBoard]
							},
							{
								title: '外机底板',
								result: valStrMap[exBaseplate]
							},
							{
								title: '电源线',
								result: valStrMap[powerLine]
							},
							{
								title: '压缩机',
								result: valStrMap[compressor]
							},
							{
								title: '蒸发器',
								result: valStrMap[evaporator]
							},
							{
								title: '冷凝器',
								result: valStrMap[condenser]
							}
						]
						return
					}
					if (this.categoryStr == '冰箱') {
						// 冰箱
						this.completeTableData = [
							{
								title: '压缩机',
								result: valStrMap[compressor]
							},
							{
								title: '压机底板',
								result: valStrMap[compressorBaseplate]
							},
							{
								title: '上下门',
								result: valStrMap[upperLowerDoor]
							},
							{
								title: '冷凝器',
								result: valStrMap[condenser]
							},
							{
								title: '蒸发器',
								result: valStrMap[evaporator]
							},
							{
								title: '储物柜',
								result: valStrMap[locker]
							},
							{
								title: '顶盖板',
								result: valStrMap[topCover]
							}
						]
						return
					}
					if (this.categoryStr == '洗衣机') {
						// 洗衣机
						this.completeTableData = [
							{
								title: '外壳',
								result: valStrMap[shell]
							},
							{
								title: '甩桶',
								result: valStrMap[spinBucket]
							},
							{
								title: '桶槽',
								result: valStrMap[bucketSlot]
							},
							{
								title: '电机',
								result: valStrMap[electricMachinery]
							},
							{
								title: '底座',
								result: valStrMap[pedestal]
							}
						]
						return
					}
					if (this.categoryStr == '平板电视') {
						// 电视机
						this.completeTableData = [
							{
								title: '外壳',
								result: valStrMap[shell]
							},
							{
								title: '外屏幕',
								result: valStrMap[externalScreen]
							}
						]
						return
					}
					// 其他无完整度质检不显示
					this.completeTableData = []
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
				}
      })
		}
	},
}
</script>
<style scoped lang="scss">
.cont-box {
	margin-bottom: 16px;
}
.img-minh {
	min-height: 120px;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	flex-wrap: wrap;
	> .img-box {
		margin-left: 12px;
		margin-top: 8px;
	}
}
.tit-name {
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 12px;
}
.image-style {
	width: 80px;
	height: 80px;
	margin-right: 20px;
}
.normal-text{
	word-break: break-all;
	overflow-wrap: break-word;
	white-space: pre-wrap;
	margin: 8px 0;
	font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/components/OldMachineDetDialog.vue